/**
 * Which instance this is, as the server injected it into index.html
 * (`CMFIS_ENVIRONMENT`, internal/handlers/filesystem). Empty on production.
 * The recolouring does not read this: it keys on `data-env` on <html>, which
 * the server writes into the markup so it applies before any script runs.
 */
export const environment = window.__CMFIS_CONFIG__?.environment ?? "";

export const isTestInstance = environment !== "" && environment !== "production";
